/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Unknown_Error_TitleInputs */

const en_dialog_unknown_error_title = /** @type {(inputs: Dialog_Unknown_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown Error Occurred`)
};

const ar_dialog_unknown_error_title = /** @type {(inputs: Dialog_Unknown_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حدث خطأ غير معروف`)
};

const de_dialog_unknown_error_title = /** @type {(inputs: Dialog_Unknown_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbekannter Fehler ist aufgetreten`)
};

const es_dialog_unknown_error_title = /** @type {(inputs: Dialog_Unknown_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se ha producido un error desconocido`)
};

const fr_dialog_unknown_error_title = /** @type {(inputs: Dialog_Unknown_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une erreur inconnue s'est produite`)
};

const it_dialog_unknown_error_title = /** @type {(inputs: Dialog_Unknown_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si è verificato un errore sconosciuto`)
};

const ja_dialog_unknown_error_title = /** @type {(inputs: Dialog_Unknown_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不明なエラーが発生しました`)
};

const ko_dialog_unknown_error_title = /** @type {(inputs: Dialog_Unknown_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`알 수 없는 오류 발생`)
};

const pt_br_dialog_unknown_error_title = /** @type {(inputs: Dialog_Unknown_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocorreu um erro desconhecido`)
};

const ru_dialog_unknown_error_title = /** @type {(inputs: Dialog_Unknown_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Произошла неизвестная ошибка`)
};

const th_dialog_unknown_error_title = /** @type {(inputs: Dialog_Unknown_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกิดข้อผิดพลาดที่ไม่ทราบสาเหตุ`)
};

const tr_dialog_unknown_error_title = /** @type {(inputs: Dialog_Unknown_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilinmeyen Hata Oluştu`)
};

const zh_cn_dialog_unknown_error_title = /** @type {(inputs: Dialog_Unknown_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发生未知错误`)
};

const zh_tw_dialog_unknown_error_title = /** @type {(inputs: Dialog_Unknown_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`發生未知錯誤`)
};

/**
* | output |
* | --- |
* | "Unknown Error Occurred" |
*
* @param {Dialog_Unknown_Error_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_unknown_error_title = /** @type {((inputs?: Dialog_Unknown_Error_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Unknown_Error_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_unknown_error_title(inputs)
	if (locale === "ar") return ar_dialog_unknown_error_title(inputs)
	if (locale === "de") return de_dialog_unknown_error_title(inputs)
	if (locale === "es") return es_dialog_unknown_error_title(inputs)
	if (locale === "fr") return fr_dialog_unknown_error_title(inputs)
	if (locale === "it") return it_dialog_unknown_error_title(inputs)
	if (locale === "ja") return ja_dialog_unknown_error_title(inputs)
	if (locale === "ko") return ko_dialog_unknown_error_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_unknown_error_title(inputs)
	if (locale === "ru") return ru_dialog_unknown_error_title(inputs)
	if (locale === "th") return th_dialog_unknown_error_title(inputs)
	if (locale === "tr") return tr_dialog_unknown_error_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_unknown_error_title(inputs)
	return zh_tw_dialog_unknown_error_title(inputs)
});